import request from './request';
import deserialize from './deserialize';
import moment from 'moment';

export type RewardCard = {
  id: string;
  expiresAt: number;
  merchantName: string;
  receivedAt: number;
  redeemedAt: number;
  remind: boolean;
  source: string;
  status: string;
  title: string;
  updatedAt: number;
  user: { id: string };
  merchant: { id: string };
  owner: { id: string };
  redemptionStore: { id: string };
  reward: { id: string };
};

export function listCollected(companyId: string, memberId: string) {
  const now = parseInt(moment().format('X'), 10);

  return request<RewardCard[]>({
    url: `/companion/v1/companies/${companyId}/member/${memberId}/reward_cards?filter[status][eq]=collected&filter[expiresAt][gt]=${now}`,
    method: 'GET',
    transformResponse: deserialize,
  });
}

export function listExpiredCollected(companyId: string, memberId: string) {
  return request<RewardCard[]>({
    url: `/companion/v1/companies/${companyId}/member/${memberId}/reward_cards?filter[status][eq]=collected`,
    method: 'GET',
    transformResponse: deserialize,
  });
}

export function listExpired(companyId: string, memberId: string) {
  return request<RewardCard[]>({
    url: `/companion/v1/companies/${companyId}/member/${memberId}/reward_cards?filter[status][eq]=expired`,
    method: 'GET',
    transformResponse: deserialize,
  });
}

export function listRedeemed(companyId: string, memberId: string) {
  return request<RewardCard[]>({
    url: `/companion/v1/companies/${companyId}/member/${memberId}/reward_cards?filter[status][eq]=redeemed`,
    method: 'GET',
    transformResponse: deserialize,
  });
}

export function deleteRewardCard(
  companyId: string,
  memberId: string,
  rewardCardId: string
) {
  return request<any>({
    url: `/companion/v1/companies/${companyId}/member/${memberId}/reward_card/${rewardCardId}`,
    method: 'DELETE',
    transformResponse: deserialize,
  });
}

interface RedeemAttrs {
  companyId: string;
  rewardCardId: string;
  memberID: string;
  pin: string;
}

export function redeem(attrs: RedeemAttrs) {
  const { companyId, rewardCardId, memberID, pin } = attrs;

  return request<RewardCard>({
    url: `/companion/v1/companies/${companyId}/reward_cards/${rewardCardId}/redeem`,
    method: 'PATCH',
    data: {
      data: {
        attributes: {
          memberID,
          pin,
        },
      },
    },
    transformResponse: deserialize,
  });
}

interface IssueAttrs {
  companyId: string;
  memberID: string;
  validityPeriodDays?: number;
  expiryDate?: number;
  rewardTemplateIDs: string[];
}

export function issue(attrs: IssueAttrs) {
  const {
    companyId,
    validityPeriodDays,
    memberID,
    expiryDate,
    rewardTemplateIDs,
  } = attrs;

  if (validityPeriodDays) {
    return request<RewardCard>({
      url: `/companion/v1/companies/${companyId}/member/${memberID}/reward_cards`,
      method: 'POST',
      data: {
        data: {
          attributes: {
            rewardTemplateIDs,
            validityPeriodDays,
          },
        },
      },
      transformResponse: deserialize,
    });
  }
  if (expiryDate) {
    return request<RewardCard>({
      url: `/companion/v1/companies/${companyId}/member/${memberID}/reward_cards`,
      method: 'POST',
      data: {
        data: {
          attributes: {
            rewardTemplateIDs,
            expiryDate,
          },
        },
      },
      transformResponse: deserialize,
    });
  }
}
